<adapt-dialog [maxWidth]="dialogWidth"
              [showHelpButton]="false"
              [expandable]="true">
    <h3 adapt-dialog-title>{{ title }}</h3>

    <div adapt-dialog-content>
        <div class="mb-4">
            <h3>Name</h3>
            <dx-text-box #focus
                         [value]="data.systemComponent.name"
                         (valueChange)="onNameChange($event)"
                         [adaptValidateEntity]="data.systemComponent"
                         adaptValidateEntityProperty="name"></dx-text-box>
        </div>
        <div class="mb-0">
            <h3>Document</h3>
            @if (useDocumentSelector) {
                <adapt-select-document [(url)]="data.systemDocument.url"
                                       (urlChange)="validateSystemDocument()"
                                       (selectedDocumentChange)="clearErrorMessage()"
                                       (selectedDocumentError)="setErrorMessage($event)"></adapt-select-document>
            } @else {
                <adapt-html-editor [(contents)]="data.systemDocument.content"
                                   forceSize="standard"
                                   [minHeight]="150"
                                   (isValidChange)="isEditorValid = $event"
                                   data-test="system-document-content"></adapt-html-editor>
            }
        </div>
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   [saveIsDisabled]="!isEditorValid || hasErrorMessage"
                                   [discardConfirmationInstance]="instance"
                                   [saveBlockingClick]="saveAndClose"></adapt-standard-dialog-buttons>
</adapt-dialog>
